import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/lib/data";

export default function ReviewsPage() {
  return (
    <div>
      <section className="py-16 lg:py-24 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-sm font-semibold tracking-[0.18em] uppercase text-[#081537] mb-3">Customer Reviews</div>
          <h1 className="font-[Outfit] text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#0F172A] text-balance max-w-3xl">
            850+ five-star reviews from Kochi families.
          </h1>
          <div className="mt-6 flex items-center gap-3">
            <div className="flex">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" />)}
            </div>
            <span className="text-lg text-slate-700 font-medium">4.9/5 average rating</span>
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t) => (
            <div key={t.name} data-testid={`review-${t.name.toLowerCase().replace(/\s+/g, "-")}`} className="bg-slate-50 rounded-2xl p-7 border border-slate-100">
              <div className="flex gap-1 mb-4">
                {[...Array(t.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />)}
              </div>
              <p className="text-slate-700 leading-relaxed">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-5 pt-5 border-t border-slate-200 flex items-center gap-3">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover" />
                <div>
                  <div className="font-semibold text-[#0F172A] text-sm">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
